// USO POR SECCIÓN + ERRORES EN PANTALLA (1-oct-2026, OK Carlos).
// El 1.er día sin Kydemy no había forma de saber qué secciones usa cada quien ni qué errores ve:
// el access log no lleva usuario y la auditoría del servidor solo guarda escrituras.
// Aquí se juntan eventos y se mandan en lotes a POST /api/letsmove/telemetry (tabla
// letsmove_usage_events). El servidor normaliza la ruta (/members/123 → /members/:id) y no
// registra nada en «Ver como» ni con cuentas @lealify.com.
// Nunca debe estorbar: todo va en try/catch y un fallo de red se descarta en silencio.

type Evento = { k: 'view' | 'error'; p: string; m?: string };

const URL_TELEMETRIA = '/api/letsmove/telemetry';
const cola: Evento[] = [];
let temporizador: ReturnType<typeof setTimeout> | null = null;
let ultimaVista = '';
const erroresRecientes = new Map<string, number>();   // mensaje+ruta → ms (anti-ráfaga)

function rutaActual(): string {
  try { return window.location.pathname; } catch { return '/'; }
}

function enviar(keepalive = false) {
  if (temporizador) { clearTimeout(temporizador); temporizador = null; }
  if (!cola.length) return;
  const events = cola.splice(0, 25);
  try {
    fetch(URL_TELEMETRIA, {
      method: 'POST', credentials: 'include', keepalive,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ events }),
    }).catch(() => { /* informativo */ });
  } catch { /* informativo */ }
  if (cola.length) programar();
}

function programar() {
  if (cola.length >= 20) { enviar(); return; }
  if (!temporizador) temporizador = setTimeout(() => enviar(), 8000);
}

/** Abrió una sección (se llama en cada cambio de ruta). */
export function registrarVista(path: string) {
  if (!path || path === ultimaVista || path.startsWith('/login')) return;
  ultimaVista = path;
  cola.push({ k: 'view', p: path });
  programar();
}

/** Error que la persona vio en pantalla (aviso rojo, lectura rechazada, fallo de JS). */
export function registrarError(mensaje: string) {
  const m = String(mensaje || '').trim().slice(0, 300);
  if (!m) return;
  const p = rutaActual();
  const llave = `${p}|${m}`;
  const ahora = Date.now();
  if ((erroresRecientes.get(llave) || 0) > ahora - 60000) return;   // mismo error, misma pantalla: 1/min
  erroresRecientes.set(llave, ahora);
  cola.push({ k: 'error', p, m });
  programar();
}

let instalado = false;
/** Errores de JS no atrapados + envío al ocultar la pestaña. Se llama una vez al arrancar. */
export function instalarTelemetria() {
  if (instalado) return;
  instalado = true;
  try {
    window.addEventListener('error', (e) => {
      // Fallos de carga de recursos (imágenes) no son errores de la app.
      if (!(e instanceof ErrorEvent) || !e.message) return;
      registrarError(`JS: ${e.message}`);
    });
    window.addEventListener('unhandledrejection', (e) => {
      const r: any = e.reason;
      // Los ApiError ya los cubren la auditoría del servidor o el aviso rojo; aquí solo lo inesperado.
      if (r && typeof r.status === 'number') return;
      registrarError(`JS: ${r && r.message ? r.message : String(r)}`);
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') enviar(true);
    });
  } catch { /* informativo */ }
}
